var _path, _mask, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectEmployee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 118,
    viewBox: "0 0 196 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.949 43.0367C159.694 38.988 164.208 31.6024 164.208 23.1625C164.208 10.3702 153.838 0 141.046 0C128.254 0 117.883 10.3702 117.883 23.1625C117.883 31.6688 122.469 39.1042 129.303 43.1316C105.417 46.3485 87 66.8142 87 91.5814C87 95.1815 89.9185 98.1 93.5186 98.1H189.481C193.082 98.1 196 95.1815 196 91.5814C196 66.5561 177.197 45.9223 152.949 43.0367Z",
    fill: "#20202C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_1208_36639)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1208_36639",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3711 52.496C86.5729 47.7054 92.0833 38.8087 92.0833 28.625C92.0833 13.3681 79.7152 1 64.4583 1C49.2015 1 36.8333 13.3681 36.8333 28.625C36.8333 38.7702 42.3021 47.638 50.4525 52.4414C21.9648 56.278 0 80.6867 0 110.225C0 114.519 3.48077 118 7.77452 118H126C128.209 118 130 116.209 130 114V111.917C130 81.6204 107.546 56.5686 78.3711 52.496Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3711 52.496C86.5729 47.7054 92.0833 38.8087 92.0833 28.625C92.0833 13.3681 79.7152 1 64.4583 1C49.2015 1 36.8333 13.3681 36.8333 28.625C36.8333 38.7702 42.3021 47.638 50.4525 52.4414C21.9648 56.278 0 80.6867 0 110.225C0 114.519 3.48077 118 7.77452 118H126C128.209 118 130 116.209 130 114V111.917C130 81.6204 107.546 56.5686 78.3711 52.496Z",
    fill: "#20202C",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.3711 52.496L77.8668 51.6325L75.3756 53.0875L78.2328 53.4864L78.3711 52.496ZM50.4525 52.4414L50.586 53.4325L53.4494 53.0468L50.9603 51.5799L50.4525 52.4414ZM91.0833 28.625C91.0833 38.4388 85.7743 47.0138 77.8668 51.6325L78.8755 53.3595C87.3716 48.397 93.0833 39.1786 93.0833 28.625H91.0833ZM64.4583 2C79.1629 2 91.0833 13.9204 91.0833 28.625H93.0833C93.0833 12.8158 80.2675 0 64.4583 0V2ZM37.8333 28.625C37.8333 13.9204 49.7537 2 64.4583 2V0C48.6492 0 35.8333 12.8158 35.8333 28.625H37.8333ZM50.9603 51.5799C43.1023 46.9488 37.8333 38.4017 37.8333 28.625H35.8333C35.8333 39.1386 41.502 48.3272 49.9448 53.3029L50.9603 51.5799ZM1 110.225C1 81.1941 22.5878 57.2032 50.586 53.4325L50.3191 51.4504C21.3418 55.3529 -1 80.1793 -1 110.225H1ZM7.77452 117C4.03305 117 1 113.967 1 110.225H-1C-1 115.072 2.92849 119 7.77452 119V117ZM126 117H7.77452V119H126V117ZM129 114C129 115.657 127.657 117 126 117V119C128.761 119 131 116.761 131 114H129ZM129 111.917V114H131V111.917H129ZM78.2328 53.4864C106.92 57.491 129 82.1262 129 111.917H131C131 81.1146 108.171 55.6462 78.5094 51.5056L78.2328 53.4864Z",
    fill: "#E0E0E0",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "overlay"
    },
    mask: "url(#path-2-inside-1_1208_36639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_1208_36639",
    x: -14,
    y: -13,
    width: 158,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1208_36639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1208_36639",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1208_36639"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1208_36639",
    result: "effect3_innerShadow_1208_36639"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectEmployee);
export default __webpack_public_path__ + "static/media/select-employee.38d0ed574cbd3582fa1d342803efba78.svg";
export { ForwardRef as ReactComponent };